module.exports = __webpack_public_path__ + "static/media/lamp-on.bf23ffba.svg";